import React, { useEffect, useState } from "react";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/captions.css";
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Captions from "yet-another-react-lightbox/plugins/captions";
import Inline from "yet-another-react-lightbox/plugins/inline";
const AgentProfilerCharts = ({ charts }) => {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);
    const [slides, setSlides] = useState([]);
    useEffect(() => {
        const chartResponseValues = Object.values(charts);
        const slides = chartResponseValues
            .map((obj) => Object.entries(obj).map(([key, value]) => ({ src: value, alt: key, title: key })))
            .flat();
        setSlides(slides);
    }, [charts]);
    const toggleOpen = (state) => () => setOpen(state);
    const updateIndex = (when) => ({ index: current }) => {
        if (when === open) {
            setIndex(current);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Lightbox, { index: index, plugins: [Inline], open: open, close: () => setOpen(false), slides: slides, on: {
                view: updateIndex(false),
                click: toggleOpen(true)
            }, carousel: {
                padding: 0,
                spacing: 0,
                imageFit: "contain"
            }, styles: {
                slide: {
                    background: "white"
                }
            }, inline: {
                style: {
                    width: "100%",
                    height: "500px",
                    margin: "20px auto 0"
                }
            } }),
        React.createElement(Lightbox, { plugins: [Zoom, Captions], open: open, close: toggleOpen(false), index: index, slides: slides, on: { view: updateIndex(true) }, animation: { fade: 0 }, controller: { closeOnPullDown: true, closeOnBackdropClick: true } })));
};
export default AgentProfilerCharts;
